/** FNV-1a, 32 бита: сумма снимка мира и версии содержимого. */
const OFFSET = 0x811c9dc5;
const PRIME = 0x01000193;

export function hashInts(values: readonly number[], seed = OFFSET): number {
  let hash = seed;
  for (const value of values) {
    hash = Math.imul(hash ^ (value & 0xff), PRIME);
    hash = Math.imul(hash ^ ((value >>> 8) & 0xff), PRIME);
    hash = Math.imul(hash ^ ((value >>> 16) & 0xff), PRIME);
    hash = Math.imul(hash ^ ((value >>> 24) & 0xff), PRIME);
  }
  return hash >>> 0;
}

export function hashString(text: string, seed = OFFSET): number {
  let hash = seed;
  for (let index = 0; index < text.length; index++) hash = Math.imul(hash ^ text.charCodeAt(index), PRIME);
  return hash >>> 0;
}
